<template>
  <div class="atlas-wrap">
    <div class="w">
      <divider chinese="你若需要 我必努力" english="IF YOU NEED I WILL TRY TO"/>
      <div class="map-wrap">
        <div
          class="province"
          @click="handleMarkClick(index, item.citys.length)"
          :class="active === index ? 'active': ''"
          v-for="(item, index) in mapDataArray"
          :key="item.key"
          :style="`left: ${item.x}px; top: ${item.y}px`"
        >
          <div class="mark" :class="{'active': isMarkShake && index === active}">
            <p class="number" :class="item.citys.length > 0 ? 'active': ''">
              <span>{{ item.citys.length }}</span>
            </p>
            <p class="text">{{ item.province }}</p>
            <div class="scoll-wrap" v-show="item.citys.length > 0 && cityList">
              <el-scrollbar class="page-component__scroll">
                <div
                  v-for="(org, j) in item.citys"
                  :key="org.url || j"
                  @click="handleUrl(org)"
                  class="scroll-item"
                >
                  {{ j + 1 }}. {{ org.orgName }}
                </div>
              </el-scrollbar>
              <p class="triangle el-icon-caret-bottom"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IndexDivider from '../IndexDivider.vue'
import http from '@/http/index'
import { mapMutations } from 'vuex'

// 省份映射表：标准省份名 → mapData key
const PROVINCE_MAP = {
  北京市: 'beijing',
  天津市: 'tianjin',
  重庆市: 'chongqing',
  上海市: 'shanghai',
  广东省: 'guangdong',
  黑龙江省: 'heilongjiang',
  新疆维吾尔自治区: 'xinjiang',
  西藏自治区: 'xizang',
  青海省: 'qinghai',
  四川省: 'sichuan',
  云南省: 'yunnan',
  甘肃省: 'gansu',
  内蒙古自治区: 'neimenggu',
  宁夏回族自治区: 'ningxia',
  陕西省: 'shanxi1',
  山西省: 'shanxi2',
  河南省: 'henan',
  湖北省: 'hubei',
  湖南省: 'hunan',
  贵州省: 'guizhou',
  广西壮族自治区: 'guangxi',
  河北省: 'hebei',
  山东省: 'shandong',
  江苏省: 'jiangsu',
  安徽省: 'anhui',
  浙江省: 'zhejiang',
  江西省: 'jiangxi',
  福建省: 'fujian',
  台湾省: 'taiwan',
  吉林省: 'jilin',
  辽宁省: 'liaoning',
  海南省: 'hainan',
  澳门特别行政区: 'aomen',
  香港特别行政区: 'xianggang'
}

export default {
  data () {
    return {
      active: 0,
      isMarkShake: false,
      cityList: false,
      // 原始 mapData 对象（保留）
      mapData: {
        beijing: { province: '北京', x: 666, y: 267, citys: [] },
        tianjin: { province: '天津', x: 681, y: 288, citys: [] },
        chongqing: { province: '重庆', x: 500, y: 472, citys: [] },
        shanghai: { province: '上海', x: 775, y: 445, citys: [] },
        guangdong: { province: '广东', x: 612, y: 602, citys: [] },
        heilongjiang: { province: '黑龙江', x: 802, y: 104, citys: [] },
        xinjiang: { province: '新疆', x: 151, y: 217, citys: [] },
        xizang: { province: '西藏', x: 151, y: 394, citys: [] },
        qinghai: { province: '青海', x: 315, y: 345, citys: [] },
        sichuan: { province: '四川', x: 397, y: 471, citys: [] },
        yunnan: { province: '云南', x: 381, y: 583, citys: [] },
        gansu: { province: '甘肃', x: 330, y: 253, citys: [] },
        neimenggu: { province: '内蒙古', x: 527, y: 253, citys: [] },
        ningxia: { province: '宁夏', x: 504, y: 324, citys: [] },
        shanxi1: { province: '陕西', x: 518, y: 399, citys: [] },
        shanxi2: { province: '山西', x: 583, y: 347, citys: [] },
        henan: { province: '河南', x: 596, y: 399, citys: [] },
        hubei: { province: '湖北', x: 596, y: 465, citys: [] },
        hunan: { province: '湖南', x: 569, y: 530, citys: [] },
        guizhou: { province: '贵州', x: 479, y: 551, citys: [] },
        guangxi: { province: '广西', x: 516, y: 603, citys: [] },
        hebei: { province: '河北', x: 636, y: 313, citys: [] },
        shandong: { province: '山东', x: 679, y: 345, citys: [] },
        jiangsu: { province: '江苏', x: 723, y: 400, citys: [] },
        anhui: { province: '安徽', x: 686, y: 434, citys: [] },
        zhejiang: { province: '浙江', x: 735, y: 492, citys: [] },
        jiangxi: { province: '江西', x: 661, y: 515, citys: [] },
        fujian: { province: '福建', x: 701, y: 551, citys: [] },
        taiwan: { province: '台湾', x: 780, y: 595, citys: [] },
        jilin: { province: '吉林', x: 798, y: 180, citys: [] },
        liaoning: { province: '辽宁', x: 741, y: 231, citys: [] },
        hainan: { province: '海南', x: 549, y: 713, citys: [] },
        aomen: { province: '澳门', x: 637, y: 652, citys: [] },
        xianggang: { province: '香港', x: 655, y: 632, citys: [] }
      }
    }
  },
  computed: {
    // 将 mapData 转为数组，便于 v-for 遍历并保持顺序
    mapDataArray () {
      return Object.keys(this.mapData).map(key => ({
        key,
        ...this.mapData[key]
      }))
    }
  },
  async created () {
    try {
      const res = await http.getOrglist()
      const data = res?.data?.data

      // 安全检查：确保 data 存在且是数组
      if (!Array.isArray(data)) {
        console.warn('getOrglist 接口返回数据异常，未获取到机构列表')
        return
      }

      // 清空所有 citys
      Object.values(this.mapData).forEach(item => {
        item.citys = []
      })

      // 分配机构到对应省份
      data.forEach(item => {
        const key = PROVINCE_MAP[item.province]
        if (key && this.mapData[key]) {
          this.mapData[key].citys.push(item)
        } else {
          console.warn('未识别的省份:', item.province)
        }
      })
    } catch (error) {
      console.error('加载机构列表失败:', error)
    }
  },
  methods: {
    ...mapMutations(['handleHistoryOrganization']),
    handleMarkClick (index, length) {
      if (this.active === index) {
        this.cityList = !this.cityList
      } else {
        this.active = index
        this.cityList = true
        this.isMarkShake = length === 0
      }
    },
    handleUrl (data) {
      const BASE_API_TESTS = process.env.VUE_APP_BASE_API_TESTS
      if (!data.url) return false
      window.open(BASE_API_TESTS + '#/index?abbr=' + data.url)
      this.$emit('jump')
      this.handleHistoryOrganization(data)
    }
  },
  components: {
    divider: IndexDivider
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/sass/variable.scss';

::v-deep(.page-component__scroll) {
  height: 100%;
}

::v-deep(.page-component__scroll .el-scrollbar__wrap) {
  overflow-x: auto;
}

.atlas-wrap {
  width: 100%;
  height: 980px;
  background: url('../../assets/images/mapbg.png') no-repeat;
  background-size: cover;

  .w {
    width: $el-center;
    margin: 0 auto;

    .map-wrap {
      width: 930px;
      height: 744px;
      background: url("../../assets/images/map.png") no-repeat;
      background-size: cover;
      margin: 0 auto;
      position: relative;

      .province {
        position: absolute;
        cursor: pointer;

        &.active {
          .mark {
            .scoll-wrap {
              display: block;
            }
          }
        }

        .mark {
          display: flex;
          align-items: center;
          position: relative;

          &.active {
            animation: shake 0.3s ease-in-out;
          }

          .number {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: #FD6A00;
            text-align: center;
            line-height: 20px;
            font-size: 12px;
            color: #fff;
            position: relative;

            span {
              width: 20px;
              height: 20px;
              position: absolute;
              top: 50%;
              left: 50%;
              margin: -10px -10px;
              z-index: 10;
            }

            &.active {
              &::after {
                content: '';
                display: block;
                width: 30px;
                height: 30px;
                background: rgba(253, 106, 0, 0.4);
                border-radius: 50%;
                position: absolute;
                top: 50%;
                left: 50%;
                margin: -15px -15px;
                z-index: 5;
                animation: breath 1s ease-in-out infinite alternate;
              }

              &::before {
                content: '';
                display: block;
                width: 40px;
                height: 40px;
                background: rgba(253, 106, 0, 0.3);
                border-radius: 50%;
                position: absolute;
                top: 50%;
                left: 50%;
                margin: -20px -20px;
                z-index: 2;
                animation: breath 1s ease-in-out infinite alternate;
              }
            }
          }

          .text {
            padding: 3px 10px;
            background: #fff;
            font-size: 12px;
            color: #333333;
            border-radius: 2px;
            margin-left: 5px;
          }

          .scoll-wrap {
            width: 300px;
            height: 150px;
            position: absolute;
            bottom: 0;
            left: 50%;
            background: #fff;
            margin: 40px -152px;
            z-index: 100;
            display: none;
            box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
            border-radius: 5px;

            .scroll-item {
              font-size: 14px;
              text-align: left;
              padding: 10px 15px;

              &:hover {
                background: rgba(0, 0, 0, 0.1);
                color: $el-main-color;
              }
            }

            .triangle {
              color: #fff;
              font-size: 35px;
              text-shadow: 0 5px 5px rgba(0, 0, 0, 0.3);
              position: absolute;
              bottom: -21px;
              left: 50%;
              transform: translate(-50%);
            }
          }
        }
      }
    }
  }
}

@keyframes breath {
  0% { transform: scale(0.8); }
  100% { transform: scale(1); }
}

@keyframes shake {
  0% { transform: translate3d(-2px, 0, 0); }
  25% { transform: translate3d(2px, 0, 0); }
  50% { transform: translate3d(-2px, 0, 0); }
  75% { transform: translate3d(2px, 0, 0); }
  100% { transform: translate3d(0, 0, 0); }
}
</style>
